import s from "styled-components";
import { HeartsPreloader } from "_c/preloader";
import { breakPoints } from "../../index-styled";

export const CommentsWrap = s.ul`
  overflow-y: auto;
  height: 100%;
  background-color: var(--bg-paper);
  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 45px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
    border-radius: 45px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--color-primary);
    border-radius: 45px;
  }
  @media(max-width: ${breakPoints.sm.bp}) {
    min-height: 100px;
    overflow: visible;
    height: auto;
  }
`;
export const CommentForm = s.form`
  height: 35px;
  position: relative;
  border-top: 1px solid rgba(0,0,0,.1);
  margin-top: auto;
  input {
    background: var(--bg-touchable);
    color: var(--font-color-main);
    width: 100%;
    border: none;
    outline: none;
    padding: 8px;
    padding-left: 15px;
    padding-right: 32px;
  }  
  @media(max-width: ${breakPoints.sm.bp}) {
    position: fixed;
    bottom: 37px;
    left: 0;
    width: 100%;
    margin: 0;
  }
`;
export const SubmitButton = s.button`
  position: absolute;
  right: 5px;
  top: 5px;
`;
export const Preloader = s(HeartsPreloader)`
  display: block;
  margin: 25px auto;
`;
